export const Privacies = [
    {
        title: "Adashiesusuakawo's Data Collection:",
        word: [
            "Adashiesusuakawo, operating the mobile app, collects various data to improve services.",
            "Information is gathered through feedback, online forms, surveys, social media interactions, and third-party sources like Google Analytics.",
            "Collected information includes Personal Data (e.g., name, email, phone number), Usage Data (device information), and cookies for site activity tracking.",
        ],
    },
    {
        title: "Data Usage:",
        word: [
            "Data is used for service maintenance, user notifications, customer support, analysis, and issue detection.",
            "Adashiesusuakawo does not sell personal info but might share aggregated non-identifiable data.",
            "Data may be transferred globally with stringent security measures in place.",
        ],
    },
    {
        title: "User Privacy Rights:",
        word: [
            "Users have rights regarding data access, correction, deletion, and objection to processing.",
        ],
    },
    {
        title: "Security Measures:",
        word: [
            "Security measures are implemented to safeguard user data.",
            "Third-party service providers assist in service analysis.",
        ],
    },
    {
        title: "External Links and Children's Privacy:",
        word: [
            "The policy addresses links to external sites and Children's Privacy.",
        ],
    },
    {
        title: "Complaint Resolution:",
        word: ["Procedures for resolving complaints and disputes are outlined."],
    },
    {
        title: "Policy Updates and Compliance:",
        word: [
            "Periodic policy updates ensure compliance with NDPR and GDPR regulations.",
        ],
    },
    {
        title: "Contact Information::",
        word: [
            "Contact details are provided for any queries or concerns regarding the Privacy Policy.",
        ],
    },
];
